module.exports = __webpack_public_path__ + "img/Rain.dde10a75.png";